import { Tooltip } from "antd";
import { EmployerFilterOptions } from "constants/ConstantOptions";

export const StyledSpan = ({ dataToShow, tooltipTitle="" }) => {
    return (
      <Tooltip title={tooltipTitle}>
        <span
          style={{
            display: 'inline-block',
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          className="title-capitalize"
        >
          {dataToShow}
        </span>
      </Tooltip>
    );
  };


export const employerCompanyColumn = (user) => {
  if (!user?.groups?.includes("Admin")) return [];

  return [
    {
      title: 'Employer',
      dataIndex: 'employer',
      key: 'employer',
      align: 'center',
      render: (employer) => {
        const matchedCompany = EmployerFilterOptions.find(
          (option) => option.handle.toLowerCase() === employer?.toLowerCase()
        );
        return (
          <span className='gx-badge'>
            {matchedCompany ? matchedCompany.title : employer || 'N/A'}
          </span>
        );
      },
    }
  ];
}

export const isFilterEmpty = (filterObj) => {
  if (!filterObj || typeof filterObj !== 'object') return true;
  return Object.values(filterObj).every(value => {
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    if (typeof value === 'string') {
      return value.trim() === '' || value === '[]';
    }
    return value === undefined || value === null;
  });
};

let soundAllowed = false;
const audio = new Audio('/mixkit-software-interface-remove-2576.wav');

export const enableSound = () => {
  soundAllowed = true;
  // audio.play().then(() => {
  //   audio.pause();
  //   audio.currentTime = 0;
  //   console.log("✅ Sound unlocked — future sounds will play automatically!");
  // });
};

export const playNotificationSound = (unreadCount = 0, user) => {
  const count = Number(unreadCount) || 0;
  const storedCount = Number(sessionStorage.getItem("unreadNotificationCount")) || 0;
  if(user && user?.groups?.includes("contract")){
    if (count > storedCount) {
      if (!soundAllowed) {
        console.log("⚠️ Sound blocked — waiting for user interaction");
        return;
      }
      audio.currentTime = 0;
      audio.play().catch((err) => console.error("Sound play error:", err));
    }
  }

  sessionStorage.setItem("unreadNotificationCount", count);
};
